import {
	type ReactNode,
	useEffect,
	useState,
	useSyncExternalStore,
} from 'react'
import { createPortal } from 'react-dom'

import styles from './OverDialogLayer.module.scss'

export const OVER_TOP_LAYER_ID = 'over-top-layer'

const overTopLayerStore = {
	layer: null as HTMLDivElement | null,
	subscribers: [] as (() => void)[],
	subscribe: (fn: () => void) => {
		overTopLayerStore.subscribers.push(fn)
		return () => {
			// Unsubscribe
			overTopLayerStore.subscribers = overTopLayerStore.subscribers.filter(
				(subscriber) => subscriber !== fn
			)
		}
	},
	getSnapshot: () => {
		return overTopLayerStore.layer
	},
	getServerSnapshot: () => {
		return null
	},
	dispatchLayer: (layer: HTMLDivElement) => {
		overTopLayerStore.layer = layer
		overTopLayerStore.subscribers.forEach((fn) => fn())
	},
}

export function OverDialogLayerDialog() {
	return (
		<div
			id={OVER_TOP_LAYER_ID}
			className={styles.overTopLayer}
			ref={(ref: HTMLDivElement) => {
				overTopLayerStore.dispatchLayer(ref)
			}}
		/>
	)
}

export function OverDialogLayer({
	children,
	defaultLayer,
}: {
	children: ReactNode
	defaultLayer?: HTMLElement | null
}) {
	const [onClient, setOnClient] = useState(false)
	const overTargetLayer = useSyncExternalStore<HTMLDivElement | null>(
		overTopLayerStore.subscribe,
		overTopLayerStore.getSnapshot
	)

	useEffect(() => {
		setOnClient(true)
	}, [])

	if (!onClient) {
		return children
	}

	const targetLayer = overTargetLayer || defaultLayer || document.body

	return createPortal(<>{children}</>, targetLayer)
}
